<!--
 * @Author: zyq yqzhang01@gongsibao.com
 * @Date: 2022-08-10 14:31:02
 * @LastEditors: zyq yqzhang01@gongsibao.com
 * @LastEditTime: 2022-08-10 14:34:22
 * @FilePath: \fe-frame-page\src\views\enterpriseHighNewN\components\fromItem.vue
 * @Description: formItem组件
-->
<template>
  <div class="form-item">
    <div class="label" :class="{ required: required }">
      {{ label }} <span>{{ desc }}</span>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ["required", "label", "desc"],
};
</script>

<style lang="less" scoped>
.form-item {
  .label {
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    margin-top: 24px;
    margin-bottom: 14px;
    > span {
      color: #999999;
      margin-left: 10px;
    }
  }
  .required {
    &::before {
      content: "*";
      color: #ff0000;
      margin-right: 3px;
    }
  }
}
</style>